import type {CSSObject} from "@emotion/react";
import styled from "@emotion/styled";
import b10bg from "@/assets/images/b10Backgound.webp";

export const PushMailWrapper = styled.div<{showAd?: boolean; imgPosition?: string}>(
  ({theme, showAd}) => ({
    gridColumn: showAd ? "1/13" : theme?.breakpoints?.md ? "1/-1" : "2/16",
    maxWidth: theme?.breakpoints?.md ? "100%" : "979px",
    marginInline: showAd || theme?.breakpoints?.md ? 0 : 20,
    display: "flex",
    flexDirection: theme?.breakpoints?.isMobile ? "column-reverse" : "row",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginBlock: showAd ? 0 : 30,
    backgroundImage: `url("${b10bg}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    padding:
      showAd && theme?.breakpoints?.md
        ? "32px 60px 0 0"
        : showAd && theme?.breakpoints?.xl
          ? "32px 60px 0 100px"
          : theme?.breakpoints?.isMobile
            ? "30px 16px 0 16px"
            : "32px 60px 0 110px",
    borderRadius: 26,
    boxShadow: "0px 0px 32px 0px rgb(0 0 0 / 8%)",
  }),
);

export const PushMailImage = styled.img<{
  credit?: string;
  showAd?: boolean;
  imgPosition?: string;
}>(({theme, credit, showAd}) => ({
  position: "relative",
  alignSelf: "flex-end",
  height:
    showAd && theme?.breakpoints?.md ? 140 : theme?.breakpoints?.isMobile ? 120 : 172,
  width:
    showAd && theme?.breakpoints?.md ? 175 : theme?.breakpoints?.isMobile ? 172 : 242,
  marginRight: theme?.breakpoints?.isMobile ? 0 : theme?.breakpoints?.md ? 30 : 64,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: theme?.breakpoints?.isMobile ? "right" : "bottom",
  ":before": {
    content: credit ? `"${credit}"` : '""',
    position: "absolute",
    bottom: 5,
    left: 0,
    width: "100%",
    height: "auto",
    color: theme?.colors?.primaryGrey,
    borderRadius: 4,
    fontSize: "0.75rem",
    lineHeight: 1,
    fontWeight: 400,
    fontFamily: theme?.font?.manrope,
  },
}));

export const ContentWrapper = styled.div(
  (): CSSObject => ({
    marginBottom: 32,
    display: "flex",
    flexDirection: "column",
    width: "100%",
  }),
);

// The pictogram, the title and the text are the ones of B10PushMail, to the letter
export {
  PushMailPictogramme,
  PushMailText,
  PushMailTitle,
  TitleWrapper,
} from "../B10PushMail/styles";
